export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "sellers",
      layout: "dashboard",
    },
    path: "/sellers",
    name: "sellers",
    component: () => import("@/layouts/index/SellersIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de vendeurs",
          layout: "dashboard",
        },
        path: "index",
        name: "sellers-index",
        component: () => import("@/views/sellers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un nouveau vendeur",
          layout: "dashboard",
        },
        path: "create",
        name: "sellers-create",
        component: () => import("@/views/sellers/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le vendeur",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "sellers-edit",
        component: () => import("@/views/sellers/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Details de vendeur",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "sellers-details",
        component: () => import("@/views/sellers/Details.vue"),
      },
    ],
  },
];

